module.exports = __webpack_public_path__ + "img/header-engagementRings050Carat.d56248b.jpg";